























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { OrganisationModel, PrivatePersonModel } from "../models";
import { RelationType } from "../../../shared/store/auth/types";

@Component
export default class RelationData extends Vue {
  @Prop({ required: true })
  value!: OrganisationModel | PrivatePersonModel;
  @Prop({ required: true })
  type!: RelationType;
  @Prop({ default: false })
  link!: boolean;

  get icon() {
    return this.isPrivatePerson ? "user" : "users";
  }

  get isPrivatePerson() {
    return this.type === RelationType.private;
  }

  get isOrganisation() {
    return this.type === RelationType.contact;
  }

  get organisation() {
    if (!this.isOrganisation) return new OrganisationModel();
    return this.value as OrganisationModel;
  }

  get privatePerson() {
    if (!this.isPrivatePerson) return new PrivatePersonModel();
    return this.value as PrivatePersonModel;
  }

  get mainContact() {
    return this.organisation.contacts.find(
      c => c.id === this.organisation.main_contact
    );
  }

  get name() {
    if (this.isPrivatePerson) {
      return this.privatePerson.first_name + " " + this.privatePerson.last_name;
    }
    if (this.isOrganisation) {
      return this.organisation.name;
    }
    return "";
  }
}
